import styled from '@emotion/styled'
import {theme} from '../../theme'

export const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px;
  border: 1px solid #dde1ea;
  gap: 10px;
`

// ─── Single toolbar row ───────────────────────────────────────────────────────
// Layout: [TabToggle] [SearchWrapper flex:1] [Search btn] [+ New Account btn]

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.space[4]};
  // margin: ${theme.space[5]} 0;
  flex-wrap: wrap;
  // padding: ${theme.space[4]};
`

export const SearchWrapper = styled.div`
  flex: 1;
  min-width: 500px;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
`

// Static section heading used where a navigating tab toggle isn't wanted
// (e.g. the Keap Partner Control Center, which renders My Accounts in-pane).
export const SectionTitle = styled.h2`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  background: #dfe5f7;
  border-radius: 6px;
  padding: 4px 10px;
  height: 36px;
`

export const AccountList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${theme.space[2]};
  padding: 0;
  margin: 0;
`

export const EmptyState = styled.li`
  text-align: center;
  padding: ${theme.space[12]} 0;
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.text.muted};
`

export const StatusMessage = styled.p`
  text-align: center;
  padding: 20px 0 10px;
`

// ─── Pagination ───────────────────────────────────────────────────────────────
export const PaginationBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.space[3]};
  padding: ${theme.space[4]};
  flex-wrap: wrap;
`

export const PaginationInfo = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.muted};
`

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.space[3]};
`

export const PageButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid ${theme.colors.border?.default ?? '#d0d5dd'};
  border-radius: 6px;
  background: #fff;
  font-size: ${theme.fontSizes.sm};
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

// ─── SearchRow ────────────────────────────────────────────────────────────────
// Wraps the search input + New Account button in a single aligned row.
// Sits to the right of TabToggle inside Toolbar.

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.space[3]};
  height: 100%;
`
